import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import BottomTabNavigator from 'src/presentation/navigation/navigators/BottomTabNavigator';
import MessagesStackNavigator from 'src/presentation/navigation/navigators/MessagesStackNavigator';
import type { MainNavigation } from 'src/presentation/navigation/types/NavigationTypes';

const Stack = createStackNavigator<MainNavigation>();

export default function MainStackNavigator() {
	return (
		<Stack.Navigator screenOptions={{ headerShown: false, cardStyle: { flex: Dimens.flex1 } }}>
			<Stack.Screen component={BottomTabNavigator} name={Constants.navigatorBottomTab} />
			<Stack.Screen
				component={MessagesStackNavigator}
				name={Constants.navigatorMessages}
				options={{
					presentation: 'modal',
				}}
			/>
		</Stack.Navigator>
	);
}
